import { ANALYTICS_DISABLED } from '@/config/analytics';

const VK_PIXEL_ID = process.env.VUE_APP_VK_PIXEL_ID || '3766207';
const DSP_SID = process.env.VUE_APP_DSP_SID || '234134';

const DSP_SITE_AREA_MAP = {
  login: 'jRgqZQb4',
  where_to_buy: 'vOxcoB9i',
  upload_click: 'qRyeTN0P',
  registration: 'sBxDK6Dv',
  upload_success: 'unVvwyEo',
};

const GOAL_TO_PIXEL_EVENT = {
  SignIn_SentForm_Success: 'login',
  click_store: 'where_to_buy',
  Check_Click: 'upload_click',
  SignUp_SentForm_Success: 'registration',
  upload_check_succes: 'upload_success',
};

let vkReadyPromise = null;
let dspReadyPromise = null;

function ensureWindow() {
  return typeof window !== 'undefined';
}

function loadVkPixel() {
  if (ANALYTICS_DISABLED || !ensureWindow() || !VK_PIXEL_ID) return null;
  if (vkReadyPromise) return vkReadyPromise;

  vkReadyPromise = new Promise((resolve) => {
    if (window.VK?.Retargeting?.Init) {
      try {
        window.VK.Retargeting.Init(VK_PIXEL_ID);
      } catch (e) {
        resolve(null);
        return;
      }
      resolve(window.VK.Retargeting);
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://vk.com/js/api/openapi.js?179';
    script.onload = () => {
      try {
        if (window.VK?.Retargeting?.Init) {
          window.VK.Retargeting.Init(VK_PIXEL_ID);
          resolve(window.VK.Retargeting);
        } else {
          resolve(null);
        }
      } catch (e) {
        resolve(null);
      }
    };
    script.onerror = () => resolve(null);
    document.head.appendChild(script);
  });

  return vkReadyPromise;
}

function loadDspCounter() {
  if (ANALYTICS_DISABLED || !ensureWindow()) return null;
  if (dspReadyPromise) return dspReadyPromise;

  dspReadyPromise = new Promise((resolve) => {
    // Библиотека падает, если window.DSPCounter не определён.
    // Даем пустой объект-заглушку до загрузки скрипта.
    if (!window.DSPCounter) {
      window.DSPCounter = { loaded: false, q: [] };
    }

    if (typeof window.DSPCounter === 'function') {
      resolve(window.DSPCounter);
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://counter.reddigital.ru/DSPCounter.js';
    script.onload = () => resolve(typeof window.DSPCounter === 'function' ? window.DSPCounter : null);
    script.onerror = () => resolve(null);
    document.head.appendChild(script);
  });

  return dspReadyPromise;
}

async function sendVkEvent(eventName) {
  const vk = await loadVkPixel();
  if (!vk || typeof vk.Event !== 'function') return;
  try {
    vk.Event(eventName);
  } catch (e) {
    // noop
  }
}

async function sendDspEvent(eventName) {
  const dsp = await loadDspCounter();
  if (!dsp) return;

  const payload = { sid: DSP_SID, user_id: '' };
  const siteArea = DSP_SITE_AREA_MAP[eventName];
  if (siteArea) {
    payload.site_area = siteArea;
    payload.lead_id = '';
    payload.order_sum = '';
  }

  try {
    dsp('send', payload);
  } catch (e) {
    // noop
  }
}

export function trackAllSitePixels() {
  if (ANALYTICS_DISABLED || !ensureWindow()) return;
  void loadVkPixel().then((vk) => {
    if (!vk || typeof vk.Hit !== 'function') return;
    try {
      vk.Hit();
    } catch (e) {
      // noop
    }
  });

  void sendDspEvent('all_site');
}

export function trackPixelsForGoal(goal) {
  if (!goal || ANALYTICS_DISABLED || !ensureWindow()) return;
  const eventName = GOAL_TO_PIXEL_EVENT[goal];
  if (!eventName) return;

  void sendVkEvent(eventName);
  void sendDspEvent(eventName);
}
